import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: "600px",
    maxWidth: "700px",
    borderRadius: "16px !important",
    padding: "24px",
    backgroundColor: "#ffffff",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "32px",
    borderBottom: "1px solid #f1f5f9",
    paddingBottom: "16px",
  },
  dialogTitle: {
    fontSize: "18px !important",
    fontWeight: "700 !important",
    color: "#64748b !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  breadcrumb: {
    fontSize: "14px !important",
    color: "#64748b",
    fontFamily: "'Inter', sans-serif !important",
    "& span": {
      fontWeight: "700",
      color: "#0f172a",
    },
  },
  formLabel: {
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    color: "#475569",
    marginBottom: "8px",
    fontFamily: "'Inter', sans-serif",
  },
  formInput: {
    width: "100%",
    borderRadius: "8px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      fontFamily: "'Inter', sans-serif",
      color: "#0f172a",
      backgroundColor: "#ffffff",
      "& fieldset": {
        borderColor: "#cbd5e1",
      },
      "&:hover fieldset": {
        borderColor: "#94a3b8",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#64748b",
        borderWidth: "1px",
      },
    },
  },
  dialogActions: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "16px",
    marginTop: "32px",
    padding: "0px !important",
  },
  cancelButton: {
    backgroundColor: "#eaeff5 !important",
    color: "#475569 !important",
    borderRadius: "8px !important",
    padding: "10px 24px !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#dfe5ed !important",
    },
  },
  submitButton: {
    backgroundColor: "#1e1e1e !important",
    color: "#ffffff !important",
    borderRadius: "8px !important",
    padding: "10px 24px !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    boxShadow: "none !important",
    display: "inline-flex !important",
    alignItems: "center !important",
    gap: "8px !important",
    "&:hover": {
      backgroundColor: "#2e2e2e !important",
    },
  },
}));

export default useStyles;
